export const REQUEST = 'MARKETS/REQUEST';
export const RECEIVE = 'MARKETS/RECEIVE';